import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './../pg/Global.css';
import './Palette.css';
import './Footer.css';

type FooterProps = {
    contact: string[],
    socials: string[],
    links: [string, string][],
};

const Footer: React.FC<FooterProps> = ({ contact, socials, links }) => {
    const [searchParams] = useSearchParams();
    const lang = searchParams.get("lang") ?? "en";

    return (
        <div className='FooterWrapper'>
            <div className='FooterPageName'>
                1mB33
            </div>
            <div id='FooterSpacer' />
            <div className="FooterTg">
                <div className="tg-0lax">
                    <ul>
                        {
                            contact.map((param) => {
                                return <li key={param} className='FooterLi'>
                                    <Link className='FooterLink' to={'/'}>{param.replaceAll(/(https)|(http)|(:)|(\/\/)/g, '')}</Link>
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div className="tg-0lax">
                    <ul>
                        {
                            socials.map((param) => {
                                var stripped = param.replaceAll(/(https)|(http)|(:)|(\/\/)/g, '');
                                var platform = stripped.substring(0, stripped.search(/\./));
                                platform = platform[0].toUpperCase() + platform.slice(1);
                                var rest = stripped.substring(stripped.search(/\//) + 1);

                                return <li key={param} className='FooterLi'>
                                    <img alt='' />
                                    <Link className='FooterLink' to={param}>{platform + ' ' + rest}</Link>
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div className="tg-0lax">
                    <ul>
                        {
                            links.map((param) => {
                                const url = `${param[0].length == 1 ? '' : param[0]}/?lang=${lang}`;
                                return <li key={param[0]} className='FooterLi'>
                                    <a className='FooterLink' href={url}>{param[1]}</a>
                                </li>
                            })
                        }
                    </ul>
                </div>
            </div>
            <h4 id='createdbyme'>Created by 1mB33 2026</h4>
        </div >
    );
};

export default Footer;

